<script setup lang="ts">
import { IconProps } from './IconProps';

withDefaults(defineProps<IconProps>(), {
  width: 20,
  height: 20,
  viewBox: '0 0 20 20',
  background: 'none',
  color: 'black',
  opacity: 0.32,
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :fill="background"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.0001 10C18.0001 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1218 18 10.0001 18C7.87833 18 5.8435 17.1571 4.34321 15.6569C2.84292 14.1566 2.00006 12.1217 2.00006 10C2.00006 7.87827 2.84292 5.84344 4.34321 4.34315C5.8435 2.84285 7.87833 2 10.0001 2C12.1218 2 14.1566 2.84285 15.6569 4.34315C17.1572 5.84344 18.0001 7.87827 18.0001 10ZM11.0001 6C11.0001 6.26522 10.8947 6.51957 10.7072 6.70711C10.5196 6.89464 10.2653 7 10.0001 7C9.73484 7 9.48049 6.89464 9.29295 6.70711C9.10542 6.51957 9.00006 6.26522 9.00006 6C9.00006 5.73478 9.10542 5.48043 9.29295 5.29289C9.48049 5.10536 9.73484 5 10.0001 5C10.2653 5 10.5196 5.10536 10.7072 5.29289C10.8947 5.48043 11.0001 5.73478 11.0001 6ZM9.00006 9C8.80115 9 8.61038 9.07902 8.46973 9.21967C8.32908 9.36032 8.25006 9.55109 8.25006 9.75C8.25006 9.94891 8.32908 10.1397 8.46973 10.2803C8.61038 10.421 8.80115 10.5 9.00006 10.5H9.25306C9.29047 10.5 9.3274 10.5084 9.36112 10.5246C9.39485 10.5408 9.42451 10.5643 9.44793 10.5935C9.47134 10.6227 9.48791 10.6567 9.49642 10.6932C9.50492 10.7296 9.50514 10.7675 9.49706 10.804L9.03806 12.87C8.98114 13.1259 8.98243 13.3913 9.04185 13.6466C9.10127 13.902 9.21729 14.1407 9.38135 14.3452C9.54541 14.5496 9.75331 14.7146 9.98969 14.828C10.2261 14.9413 10.4849 15.0001 10.7471 15H11.0001C11.199 15 11.3897 14.921 11.5304 14.7803C11.671 14.6397 11.7501 14.4489 11.7501 14.25C11.7501 14.0511 11.671 13.8603 11.5304 13.7197C11.3897 13.579 11.199 13.5 11.0001 13.5H10.7471C10.7097 13.5 10.6727 13.4916 10.639 13.4754C10.6053 13.4592 10.5756 13.4357 10.5522 13.4065C10.5288 13.3773 10.5122 13.3433 10.5037 13.3068C10.4952 13.2704 10.495 13.2325 10.5031 13.196L10.9621 11.13C11.019 10.8741 11.0177 10.6087 10.9583 10.3534C10.8989 10.098 10.7828 9.8593 10.6188 9.65483C10.4547 9.45036 10.2468 9.28536 10.0104 9.17201C9.77404 9.05867 9.51521 8.99989 9.25306 9H9.00006Z"
      :fill="color"
      :fill-opacity="opacity"
    />
  </svg>
</template>
